import { type LinkIcon as LinkIconValue, routes } from "@ronin/contracts";
import { cn } from "@ronin/ui";
import { useAttachmentSrc } from "../../platform/attachments.js";
import { homeIcons } from "./icons.js";

/** spec12 FR11: a Ronin icon or an uploaded image, square, at `className`'s size. */
export function LinkIcon({ icon, className }: { icon: LinkIconValue; className?: string }) {
  if (icon.kind === "image")
    return <ImageIcon attachmentId={icon.attachmentId} className={className} />;
  const Icon = homeIcons[icon.name];
  return <Icon className={cn("shrink-0", className)} aria-hidden />;
}

function ImageIcon({ attachmentId, className }: { attachmentId: string; className?: string }) {
  const src = useAttachmentSrc(routes.attachment(attachmentId));
  return src ? (
    <img src={src} alt="" className={cn("shrink-0 object-contain", className)} draggable={false} />
  ) : (
    <span className={cn("shrink-0 bg-muted", className)} aria-hidden />
  );
}
